import { render, staticRenderFns } from "./regions.vue?vue&type=template&id=3eefa0b8"
import script from "./regions.vue?vue&type=script&lang=js"
export * from "./regions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports